export function createFeaturesApi(baseUrl) {
  return {
    features: {
      getFeatures: `${baseUrl}/v1/update/features/`,
    },
  };
}
